/**
 * Liest eine Konfigurationsvariable.
 *
 * Reihenfolge:
 *  1. window.__RUNTIME_CONFIG__  – zur Laufzeit von docker-entrypoint.sh injiziert
 *  2. import.meta.env            – Vite-Build-Zeit (lokale Entwicklung)
 */
export function getEnv(key: string): string | undefined {
  if (typeof window !== 'undefined' && (window as any).__RUNTIME_CONFIG__?.[key]) {
    return (window as any).__RUNTIME_CONFIG__[key];
  }
  return (import.meta.env as any)[key];
}

/**
 * Name der geteilten Google-Drive-Ablage für Upload-Ziele.
 */
export function getSharedDriveName(): string | undefined {
  return getEnv('VITE_GOOGLE_SHARED_DRIVE_NAME') || undefined;
}
